import React, {HTMLInputTypeAttribute} from 'react';
import classNames from "classnames";


import './Input.css';


export interface SelectProps {
    value: string | number;
    min?: number;
    onChange?: (newValue: string) => void;
    onBlur?: () => void;
    disabled?: boolean;
    type?: HTMLInputTypeAttribute;
    placeholder?: string;
    className?: string;
}


export const Input = (
    {
        value,
        onChange,
        onBlur,
        disabled,
        type,
        min,
        placeholder,
        className,
    }: SelectProps
) => {
    return (
        <input className={
            classNames({
                "Input body-large": true,
                "Input--disabled": disabled,
                [className!]: className,
            })
        }
               onChange={(event) => {
                   onChange && onChange(event.target.value);
               }}
               onBlur={onBlur}
               disabled={disabled}
               value={value}
               type={type}
               min={min}
               placeholder={placeholder}
        />
    )
}
